class SideDrawer extends HTMLElement {
  constructor() {
    super();

    const thisElement = this;

    //Toggle event listeners
    this.addEventListener("drawer-toggle", function (e) {
      if (this.classList.contains("active")) {
        thisElement.close(this);
      } else {
        thisElement.open(this, e);
      }
    });

    //Key up and body click events
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    //set drawer height
    this.drawerHeight();

    //add event listener for resize
    window.addEventListener("resize", this.drawerHeight);
  }

  //Open drawer
  open(drawer, event) {
    this.drawerHeight();
    this.classList.add("active");

    if (this.id == "drawer-mini-cart") {
      document.body.classList.add("shadow--body");
    } else {
      document.body.classList.add("shadow");
    }
    
    const drawers = document.querySelectorAll(".js-drawer");

    drawers.forEach((el) => {
      el.classList.add("hide-content");
    });

    this.classList.remove("hide-content");

    this.addEventListener(
      "transitionend",
      () => {
        drawer.focus();
        trapFocus(drawer);

        if (
          event &&
          event.detail &&
          event.detail.focusSearch &&
          event.detail.search
        ) {
          event.detail.search.focus();
        }
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });
  }

  //Close drawer
  close() {
    this.classList.remove("active");
    const level = this.getAttribute("data-level");

    if (level) {
      const drawers = document.querySelectorAll(
        `.js-drawer.js-drawer-level-${level - 1}`
      );

      drawers.forEach((el) => {
        el.classList.remove("hide-content");
      });
    }

    const activeDrawers = document.querySelectorAll("side-drawer.active");
    if (!activeDrawers.length) {
      document.body.classList.remove("shadow");
      document.body.classList.remove("shadow--body");
      document.body.removeEventListener("click", this.onBodyClick, {
        passive: true,
      });
    }

    removeTrapFocus(this);
  }

  //Body click event to close drawer
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this &&
      !target.closest("side-drawer") &&
      !target.closest("side-drawer-toggle")
    ) {
      this.close();
    }
  }

  //recalculate height of drawer when viewport changes
  drawerHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );

    if (this.id == "drawer-mini-cart") {
      if (window.innerWidth < 750) {
        const uspHeight = document.querySelector(
          ".usp-banner-section"
        ).offsetHeight;
        const headerHeight =
          document.querySelector(".js-site-header").offsetHeight;

        let distance = headerHeight + uspHeight;
        if (document.querySelector(".site-header").offsetTop > uspHeight) {
          distance = headerHeight;
        }
        this.style.maxHeight = `calc(100vh - ${distance}px)`;
      } else {
        this.style.maxHeight = "calc(100vh - 20rem)";
      }
    }
  }
}

customElements.define("side-drawer", SideDrawer);
